import MuiTypography from "@mui/material/Typography";
import type { TypographyProps } from "@mui/material/Typography";

import { TestProps } from "shared/types";

type AllowedTypographyVariants = Extract<
  TypographyProps["variant"],
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "body1"
  | "body2"
  | "body3"
  | "caption"
  | "overline"
  | "button"
>;

type Props = TypographyProps &
  Omit<TypographyProps, "variant"> & {
    variant?: AllowedTypographyVariants;
  } & TestProps;

const Typography = ({ children, ...props }: Props) => (
  <MuiTypography {...props}>{children}</MuiTypography>
);

export default Typography;
